<div floatLabel="never" [formGroup]="form">
  <div class="autocomplete-input flex flex-row">
    <input type="text" matInput appNoHtmlTags trim [formControlName]="controlName" [matAutocomplete]="auto">
    <button [ngStyle]="{'visibility': (systemSelectControl.value) ? 'visible' : 'hidden'}" mat-icon-button
      aria-label="" (click)="systemSelectControl.setValue('')" [disabled]="systemSelectControl.disabled">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displaySystem.bind(this)">
    <mat-option class="autoCompleteSystem" *ngFor="let system of filteredSystems$ | async" [value]="system.machineNo" matTooltip="{{system.name}}" [disabled]="system.isConflict" matTooltipPosition="after" matTooltipClass="my-custom-tooltip">
      <span>
        {{system.name}} ({{system.machineNo}})
        <ng-container *ngIf="system.isProvisioned">
          <ng-container *ngIf="system.isConflict; else reusableTag">
            <span class="provisioned">
              &nbsp;&nbsp;&nbsp;&nbsp;CONFIGURED
            </span>
          </ng-container>
          <ng-template #reusableTag>
              <span class="provisioned-different-type">
                &nbsp;&nbsp;&nbsp;&nbsp;IN USE - AVAILABLE
              </span>
            </ng-template>
        </ng-container>
      </span>
    </mat-option>
  </mat-autocomplete>
</div>